import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import CleeQ from './Pages/Solera/CleeQ';
import Membership from './Pages/Membership';
import Gallery from './Pages/Gallery';
import AboutUs from './Pages/AboutUs';
import Excos from './Pages/Excos';
import Projects from './Pages/Projects';
import News from './Pages/News';
import Events from './Pages/Events/Events';

function App() {
  return ( 
    <div> 
      <Router>
        <Switch>  
          <Route path="/" exact component={CleeQ} /> 
          <Route path="/Membership"  component={Membership} />
          <Route path="/Events"  component={Events} />
          <Route path="/Gallery"  component={Gallery} />
          <Route path="/AboutUs"  component={AboutUs} />
          <Route path="/Excos"  component={Excos} />
          <Route path="/News"  component={News} />
          <Route path="/Projects"  component={Projects} />

       
        </Switch>
      </Router> 
    </div>
  );
}

export default App;



